import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import LoansPage from './pages/LoansPage';
import PaymentsPage from './pages/PaymentsPage';
import PaymentPage from './pages/PaymentPage';
import DocumentsPage from './pages/DocumentsPage';
import SupportPage from './pages/SupportPage';
import ProfilePage from './pages/ProfilePage';
import KycPage from './pages/KycPage';
import AdminLoansPage from './pages/AdminLoansPage';
import AdminDocumentsPage from './pages/AdminDocumentsPage';
import DashboardLayout from './components/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Main website routes */}
        <Route index element={<Navigate to="/login" replace />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />

        {/* Dashboard routes - Protected */}
        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="dashboard/loans" element={<LoansPage />} />
          <Route path="dashboard/payments" element={<PaymentsPage />} />
          <Route path="dashboard/make-payment" element={<PaymentPage />} />
          <Route path="dashboard/documents" element={<DocumentsPage />} />
          <Route path="dashboard/support" element={<SupportPage />} />
          <Route path="dashboard/profile" element={<ProfilePage />} />
          <Route path="dashboard/kyc" element={<KycPage />} />
          <Route path="dashboard/admin/loans" element={<AdminLoansPage />} />
          <Route path="dashboard/admin/documents" element={<AdminDocumentsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
